module.exports = __webpack_public_path__ + "static/media/breastfeeding.aaa089b7.svg";